const debug = process.env.NODE_ENV !== 'production';

var filesadded = [];

function loadjscssfile(filename, filetype, cb) {
	let fileref;
	if (filetype === 'js') {
		fileref = document.createElement('script');
		fileref.setAttribute('type', 'text/javascript');
		fileref.setAttribute('src', filename);
	} else if (filetype === 'css') {
		fileref = document.createElement('link');
		fileref.setAttribute('rel', 'stylesheet');
		fileref.setAttribute('type', 'text/css');
		fileref.setAttribute('href', filename);
	}
	if (typeof fileref !== 'undefined') {
		fileref.onload = function(e) {
			typeof cb === 'function' && cb(undefined, filename, filetype);
		};
		fileref.onerror = function(e) {
			typeof cb === 'function' &&
				cb(
					new Error('couldn"t load file', filename, filetype),
					filename,
					filetype
				);
		};
		document.getElementsByTagName('head')[0].appendChild(fileref);
	}
}

function checkloadjscssfile(filename, filetype, cb) {
	if (filesadded.indexOf(filename) === -1) {
		loadjscssfile(filename, filetype, cb);
		filesadded.push(filename);
	} else {
		typeof cb === 'function' && cb(null, filename, filetype);
	}
}

export const installPlugin = (pluginName, initWorkerPromise, store) => {
	const worker = new Worker(
		(debug ? '/public' : '') + '/plugins/' + pluginName + '/index.js'
	);

	initWorkerPromise(pluginName, worker).then(promise => {});
};

export const getDepCode = (
	pluginName,
	promise,
	worker,
	depPath,
	depType,
	store
) => {
	const depCode = depPath;

	if (depType === 'css') {
		checkloadjscssfile(
			(debug ? '/public' : '') + '/plugins/' + pluginName + '/' + depPath,
			depType
		);
	}

	worker.postMessage({
		depPath,
		depType,
		depCode
	});
};

export default {
	installPlugin,
	getDepCode
};
